import React from 'react';
import { DimensionDefinition } from 'libs/end-to-end/src/types/databases/dimensions/dimension-definition';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SelectBoxWithSearch } from 'apps/sigma2-ui/src/components/ui/SelectBoxWithSearch';
import { SimpleSlider } from 'apps/sigma2-ui/src/components/ui/SimpleSlider';

export const PayCorrectionChartDimensionSelect: React.FC<{
  selectedDimension: string | null;
  setSelectedDimension: Setter<string | null>;
  allDimensions: DimensionDefinition[];
  onAnalyse: (dimension: string) => void;
}> = ({
  allDimensions,
  setSelectedDimension,
  selectedDimension,
  onAnalyse,
}) => {
  const options = allDimensions.map((d) => d.columnHeaderValue);

  if (allDimensions.length < 2) {
    // Nothing to select
    return null;
  }

  // Only two options, show a slider
  if (allDimensions.length === 2) {
    const allDimensionsDisplayNameMap: Map<string, string> =
      allDimensions.reduce((acc, d) => {
        acc.set(d.columnHeaderValue, d.displayName);

        return acc;
      }, new Map<string, string>());

    return (
      <SimpleSlider
        currentValue={selectedDimension ?? options[0]}
        onChange={(selectedDimension) => {
          setSelectedDimension(selectedDimension);

          if (selectedDimension && typeof selectedDimension === 'string') {
            onAnalyse(selectedDimension);
          }
        }}
        selectableValues={options}
        getRenderValue={(columnHeaderValue) => {
          if (allDimensionsDisplayNameMap.has(columnHeaderValue)) {
            return allDimensionsDisplayNameMap.get(columnHeaderValue) ?? '';
          }

          // This should never happen
          return columnHeaderValue;
        }}
      />
    );
  }

  // More than two options, show a dropdown
  return (
    <SelectBoxWithSearch
      type={'single'}
      selected={selectedDimension ?? ''}
      setSelected={(selectedDimension) => {
        setSelectedDimension(selectedDimension);

        if (selectedDimension) {
          onAnalyse(selectedDimension);
        }
      }}
      list={allDimensions.map((d) => ({
        optionLabel: d.displayName,
        optionValue: d.columnHeaderValue,
      }))}
      label={'Dimension'}
    />
  );
};
